export enum QUERY_BACKDOOR {
  DISPLAY_CONNECT_WITH_CREDENTIALS = "displayConnectWithCredentials",
  DISPLAY_ADMIN_IMPORT_CONFIGURATION = "displayAdminImportConfiguration",
  DISPLAY_AUTH_TESTS = "displayAuthTests",
  AUTO_GUEST_AUTH = "auto-login",
  STAY_ON_LANDING_AUTH = "not-a-guest",
  DISPLAY_USER_LOGOUT_IN_HEADER = "display-user-logout-in-header",
}
